import packageInfo from '../../../../package.json';
import envVariables from '../../../consts/envVariables';
import * as originService from '../../originService';

const rum_config = {
    config: {
        sessionSampleRate: '1',
        endpoint: 'https://dataplane.rum.eu-west-1.amazonaws.com',
        telemetries: ['http', 'errors', 'performance'],
        allowCookies: false,
        enableXRay: false,
        sessionEventLimit: 0, // all events
        batchLimit: 100,
        eventCacheSize: 10000,
        dispatchInterval: 1000,
    },
    APPLICATION_ID: originService.getIsIqosDomain()
        ? envVariables.AWS_RUM_APPLICATION_ID_IQOS_DOMAIN
        : envVariables.AWS_RUM_APPLICATION_ID,
    APPLICATION_VERSION: packageInfo?.version,
    APPLICATION_REGION: envVariables.AWS_REGION,
};

export default rum_config;
